import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import BurgerMenu from './layouts/BurgerMenu/BurgerMenu';
import Accueil from './pages/Accueil/Accueil';
import BDtheque from './pages/BDtheque/BDtheque';

function App() {
  return (
    <Router>
      <div id="App">
        <BurgerMenu />
        <main>
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/Accueil" element={<Accueil />} />
            <Route path="/BDtheque" element={<BDtheque />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
